import { render } from "./GrowthRecordModal.vue?vue&type=template&id=20ba3422&scoped=true"
import script from "./GrowthRecordModal.vue?vue&type=script&lang=js"
export * from "./GrowthRecordModal.vue?vue&type=script&lang=js"

import "./GrowthRecordModal.vue?vue&type=style&index=0&id=20ba3422&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ba3422"]])

export default __exports__